import { c as _c } from "react/compiler-runtime";
import { Typography, Stack } from '@mui/material';
import type { PropsWithChildren } from 'react';
export const NumericBulletSection = t0 => {
  const $ = _c(10);
  const {
    bulletNumber,
    title,
    children
  } = t0;
  const t1 = `${bulletNumber}.`;
  let t2;
  if ($[0] !== t1) {
    t2 = <Typography variant="h4">{t1}</Typography>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <Typography variant="h4">{title}</Typography>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t3) {
    t4 = <Stack width="100%" gap="40px">{t3}{children}</Stack>;
    $[4] = children;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <Stack direction="row" gap="24px" alignItems="start">{t2}{t4}</Stack>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};